import { StatusEnum } from '../models';
export const statusUIMapXero = {
    [StatusEnum.PAID]: {
        name: 'Paid',
        portal: `Paid`,
        color: 'blue',
    },
    [StatusEnum.AUTHORISED]: {
        name: 'Approved',
        color: 'orange',
        portal: `Not Paid`,
    },
    [StatusEnum.VOIDED]: {
        name: 'Voided',
        portal: `Voided`,
        color: 'gray',
    },
    [StatusEnum.DELETED]: {
        name: 'Deleted',
        portal: `Deleted`,
        color: 'gray',
    },
    [StatusEnum.DRAFT]: {
        name: 'Draft',
        portal: `Draft`,
        color: 'gray',
    },
    [StatusEnum.SUBMITTED]: {
        name: 'Submitted',
        portal: `Submitted`,
        color: 'gray',
    },
};
//# sourceMappingURL=statusUIMapXero.js.map